export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "created_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["date created"])},
        "filter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])},
        "filter_search_buttons": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter Search Buttons"])},
        "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])},
        "status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["name"])},
        "exams": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["name"])},
          "created_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["created at"])}
        },
        "skill_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skill ID"])},
        "skill_set_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skill set ID"])},
        "skill_sets": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skill set name"])},
          "updated_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Last updated"])},
          "progress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["progress"])}
        },
        "skills": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skill name"])},
          "updated_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["last updated"])}
        },
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "training_programs": {
          "trade_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["trade code"])},
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["trade name"])}
        },
        "logbooks": {
          "progress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["progress"])}
        },
        "library_resources": {
          "created_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Created At"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Title"])}
        },
        "network_digital_assets": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Title"])},
          "created_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Created At"])}
        },
        "user_identities": {
          "first_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["First Name"])},
          "last_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Last Name"])},
          "reverse_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["apprentice name"])}
        },
        "network_memberships": {
          "created_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Created At"])}
        },
        "container_memberships": {
          "created_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Created At"])}
        },
        "resource_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resource Type"])},
        "mandatory": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mandatory"])},
        "optional": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Optional"])},
        "clear_filters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clear"])},
        "type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skill requirement"])},
        "approved": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Approved"])},
        "meets_requirements": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meets requirements"])},
        "incomplete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Incomplete"])},
        "updated_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["updated date"])},
        "default_sort": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order by"])},
        "order_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order by"])},
        "name_en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["name"])},
        "active": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active"])},
        "inactive": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inactive"])},
        "pending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pending"])},
        "exam_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exam type"])},
        "removed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Removed"])},
        "received": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Received"])},
        "sent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sent"])},
        "signed_out": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Signed out"])},
        "recalled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recalled"])},
        "not_available": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not available"])},
        "sub_location_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["exam location ID"])},
        "container": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container"])},
        "test_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["exam ID"])},
        "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All"])},
        "no_results_found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sorry, no matches found"])}
      },
      "fr": {
        "created_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["date de création"])},
        "filter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtrer"])},
        "filter_search_buttons": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Boutons de filtre de recherches"])},
        "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechercher"])},
        "status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut"])},
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["nom"])},
        "exams": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["le nom"])},
          "created_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["créer à"])}
        },
        "skill_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID de la compétence"])},
        "skill_set_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID de l’ensemble de compétences"])},
        "skill_sets": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["nom de l’ensemble de compétences"])},
          "updated_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dernière mise à jour"])},
          "progress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["état d’avancement"])}
        },
        "skills": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["nom de la compétence"])},
          "updated_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["dernière mise à jour"])}
        },
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom"])},
        "training_programs": {
          "trade_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["code du métier"])},
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["nom du métier"])}
        },
        "logbooks": {
          "progress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["état d’avancement"])}
        },
        "library_resources": {
          "created_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créé le"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Titre"])}
        },
        "network_digital_assets": {
          "created_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créé le"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Titre"])}
        },
        "user_identities": {
          "first_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prénom"])},
          "last_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom de famille"])},
          "reverse_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["nom de l'apprenti"])}
        },
        "network_memberships": {
          "created_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créé à"])}
        },
        "container_memberships": {
          "created_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créé le"])}
        },
        "resource_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type de ressource"])},
        "mandatory": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obligatoire"])},
        "optional": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facultatif"])},
        "clear_filters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effacer"])},
        "type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exigences en matière de compétences"])},
        "approved": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Approuvé"])},
        "meets_requirements": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Répond aux exigences"])},
        "incomplete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Incomplet"])},
        "updated_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["date de mise à jour"])},
        "default_sort": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gérer par"])},
        "order_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gérer par"])},
        "name_fr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["nom"])},
        "active": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actif"])},
        "inactive": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inactif"])},
        "pending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En attente"])},
        "exam_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type d’examen"])},
        "received": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reçu"])},
        "sent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyé"])},
        "signed_out": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inscrit comme sorti"])},
        "recalled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rappelé"])},
        "not_available": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non disponible"])},
        "sub_location_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["  ID du lieu d’examen"])},
        "container": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "test_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["l'identifiant (ID) de l'examen"])},
        "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tout"])},
        "no_results_found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désolé, aucune correspondance n'a été trouvée"])}
      }
    }
  })
}